/* Single source of truth for whether Keycloak is on. index.js mounts the
   AuthProvider, AuthGate gates on it and the header shows the logout button;
   all three must agree or the app white-screens (useAuth without a provider). */
const KEYCLOAK_URL = process.env.REACT_APP_KEYCLOAK_URL || '';
const KEYCLOAK_REALM = process.env.REACT_APP_KEYCLOAK_REALM || '';
const KEYCLOAK_CLIENT_ID = process.env.REACT_APP_KEYCLOAK_CLIENT_ID || '';

export const OIDC_ENABLED = Boolean(KEYCLOAK_URL && KEYCLOAK_REALM && KEYCLOAK_CLIENT_ID);

export const oidcConfig = OIDC_ENABLED ? {
  authority: `${KEYCLOAK_URL}/realms/${KEYCLOAK_REALM}`,
  client_id: KEYCLOAK_CLIENT_ID,
  // Land back where the user started (/, /domainprotection/, etc.) so the
  // same React build serves both the CertShield landing and the DM app.
  redirect_uri: window.location.origin + window.location.pathname,
  post_logout_redirect_uri: window.location.origin + '/',
  automaticSilentRenew: true,
  onSigninCallback: () => {
    // Remove OIDC query params from URL after login
    window.history.replaceState({}, document.title, window.location.pathname);
  },
} : null;
